<template>
  <v-content>
    <v-container :fluid="this.$vuetify.breakpoint.mdAndDown">
      <template v-if="$store.state.adminToken">
        <admin-nav />
        <v-card class="pa-4">
          <router-view />
        </v-card>
      </template>
      <login v-else />
    </v-container>
  </v-content>
</template>

<script>
import AdminNav from "@/components/AdminNav.vue";
import Login from "@/components/Login.vue";

export default {
  components: {
    AdminNav,
    Login
  },
  computed: {},
  mounted() {}
};
</script>

<style scoped lang="less">
@import "../assets/global.less";
</style>
